import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from '@phosphor-icons/react';

const Process = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const steps = [
    {
      step: '01',
      title: t('step1'),
      desc: t('step1Desc'),
      image: 'https://images.unsplash.com/photo-1659362549741-c32157cc71f4'
    },
    {
      step: '02',
      title: t('step2'),
      desc: t('step2Desc'),
      image: 'https://images.unsplash.com/photo-1735494035457-b6e8f68b5248'
    },
    {
      step: '03',
      title: t('step3'),
      desc: t('step3Desc'),
      image: 'https://images.unsplash.com/photo-1690049098415-29f96fca22c0'
    },
    {
      step: '04',
      title: t('step4'),
      desc: t('step4Desc'),
      image: 'https://images.pexels.com/photos/33685863/pexels-photo-33685863.jpeg'
    },
  ];

  return (
    <div className="pt-20">
      <section className="section-padding bg-[#F5F5F0]" data-testid="process-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl text-center mx-auto">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-4">
              {t('process')}
            </p>
            <h1 className={`text-5xl sm:text-6xl md:text-7xl font-light tracking-tighter leading-none mb-6 ${
              isRTL ? 'font-arabic' : 'font-heading'
            }`} data-testid="process-title">
              {t('processTitle')}
            </h1>
            <p className={`text-xl text-gray-700 ${
              isRTL ? 'font-arabic' : ''
            }`}>
              {t('processSubtitle')}
            </p>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white" data-testid="process-steps">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="space-y-24">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'md:flex-row-reverse' : ''
                }`}
                data-testid={`process-step-${index}`}
              >
                <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-[400px] object-cover"
                  />
                </div>
                <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                  <div className="text-[#C4A661] text-7xl font-light mb-4 font-heading">
                    {step.step}
                  </div>
                  <h3 className={`text-3xl sm:text-4xl font-light tracking-tight mb-4 ${
                    isRTL ? 'font-arabic' : 'font-heading'
                  }`}>
                    {step.title}
                  </h3>
                  <p className={`text-base leading-relaxed text-gray-700 ${
                    isRTL ? 'font-arabic' : ''
                  }`}>
                    {step.desc}
                  </p>
                  {index < steps.length - 1 && (
                    <div className="mt-8 flex items-center text-gray-400">
                      <ArrowRight size={24} weight="light" />
                      <div className="ml-4 h-px w-24 bg-gray-300"></div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-[#0F0F0F] text-white" data-testid="process-cta">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className={`text-4xl sm:text-5xl font-light tracking-tight mb-6 ${
            isRTL ? 'font-arabic' : 'font-heading'
          }`}>
            {isRTL ? 'هل أنت مستعد لبدء مشروعك؟' : 'Ready to Start Your Project?'}
          </h2>
          <p className={`text-lg text-gray-300 mb-8 ${
            isRTL ? 'font-arabic' : ''
          }`}>
            {isRTL 
              ? 'اتصل بنا اليوم لمناقشة احتياجات مشروعك'
              : 'Contact us today to discuss your project requirements'
            }
          </p>
          <a
            href="/contact"
            data-testid="process-cta-btn"
            className="inline-block px-10 py-4 bg-[#C4A661] text-white text-sm font-medium hover:bg-white hover:text-black transition-all duration-300"
          >
            {t('getQuote')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Process;
